import type { ReactElement } from 'react';
import type { RowOrGroup } from 'modules/campaign/plan/types';
import { useToggleGroup } from 'modules/campaign/plan/state';
import { Button } from '@ff-it/ui';
import { iconBtn } from '../../style.css';
import { PlanRowIcons } from '../../../components/PlanRowIcons';

export function RowIcon({ row }: { row: RowOrGroup }): ReactElement {
  const toggleGroup = useToggleGroup(row._key);

  return row._isGroup ? (
    <Button
      testId="toggle-group"
      variant="ghost"
      disabled={row.numChildren === 0}
      onClick={() => toggleGroup()}
      icon={row.numChildren === 0 ? 'folder-xmark' : row.isExpanded ? 'folder-open' : 'folder-closed'}
      className={iconBtn}
    />
  ) : (
    <PlanRowIcons row={row} />
  );
}
